import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyAjw2XKw3AMLboSkWoSYqYvFKAZjBPZ1J4",
  authDomain: "myreactphotoblog.firebaseapp.com",
  projectId: "myreactphotoblog",
  storageBucket: "myreactphotoblog.appspot.com",
  messagingSenderId: "580644474164",
  appId: "1:580644474164:web:fb611b5e8ec27f25582961"
};

const app = initializeApp(firebaseConfig);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
